import { categories } from "@/mocks/categories";
import { sortOptions, type SortKey } from "@/mocks/categories";

interface FilterBarProps {
  query: string;
  onQueryChange: (value: string) => void;
  category: string;
  onCategoryChange: (value: string) => void;
  sort: SortKey;
  onSortChange: (value: SortKey) => void;
  resultCount: number;
}

export default function FilterBar({
  query,
  onQueryChange,
  category,
  onCategoryChange,
  sort,
  onSortChange,
  resultCount,
}: FilterBarProps) {
  const tabs = [{ name: "全部", icon: "ri-apps-2-line" }, ...categories];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <label className="relative flex w-full items-center lg:max-w-sm">
          <span className="pointer-events-none absolute left-3 flex h-5 w-5 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base" aria-hidden="true"></i>
          </span>
          <span className="sr-only">搜索档案</span>
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="输入关键词、档案号或分类"
            className="h-10 w-full rounded-md border border-background-300 bg-background-100 pl-10 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50"
          />
        </label>

        <div className="flex flex-wrap items-center gap-3">
          <span className="font-label text-[11px] text-foreground-500 whitespace-nowrap">
            共 {resultCount} 份档案
          </span>
          <div className="flex items-center gap-2">
            <span className="font-label text-[11px] text-foreground-500 whitespace-nowrap">排序</span>
            <div className="relative">
              <select
                value={sort}
                onChange={(event) => onSortChange(event.target.value as SortKey)}
                aria-label="选择排序方式"
                className="h-10 appearance-none rounded-md border border-background-300 bg-background-100 pl-3 pr-9 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
              >
                {sortOptions.map((option) => (
                  <option key={option.key} value={option.key}>
                    {option.label}
                  </option>
                ))}
              </select>
              <span className="pointer-events-none absolute right-2.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
                <i className="ri-arrow-down-s-line text-base" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-background-200 pt-4">
        {tabs.map((tab) => {
          const active = category === tab.name;
          return (
            <button
              key={tab.name}
              type="button"
              onClick={() => onCategoryChange(tab.name)}
              aria-pressed={active}
              className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] transition-colors whitespace-nowrap ${
                active
                  ? "bg-foreground-950 text-background-50"
                  : "border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              <i className={`${tab.icon} text-[15px]`} aria-hidden="true"></i>
              {tab.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}